// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d67aedd5","879":"3d43aa38"}[chunkId] + ".chunk.js";
};